import axios from 'axios';
import * as types from '../mutation-types';

export default {
  state: {},
  getters: {
    getVisitor: state => state,
    getLevel: state => ((state.visit && state.visit.level) ? state.visit.level : null),
  },
  actions: {
    getVisitor({ commit }, login) {
      return new Promise((resolve) => {
        axios.post('https://acl.new.pixel-kraft.de/api/visitor', login).then(({ data: { data } }) => {
          commit(types.RECEIVED_VISITOR, { data });
          resolve(data);
        });
      });
    },
  },
  mutations: {
    [types.RECEIVED_VISITOR](state, { data }) {
      Object.assign(state, data);
    },
    [types.CLEARED_VISITOR](state) {
      Object.assign(state, {});
    },
  },
};
